<script setup lang="ts">
import { mdiInformationVariant, mdiChevronDown } from '@quasar/extras/mdi-v7';

type Props = {
  color?: string;
  icon?: string;
  title?: string;
  position?: 'left' | 'right' | 'top' | 'bottom' | 'standard';
  cardClass?: string;
};

withDefaults(defineProps<Props>(), {
  color: 'primary',
  icon: mdiInformationVariant,
  title: 'Instructions',
  position: 'standard',
  cardClass: '',
});

const emit = defineEmits<{
  hide: [];
}>();
const isOpen = defineModel<boolean>('isOpen', { default: false });
</script>

<template>
  <q-dialog
    v-model="isOpen"
    :position="position"
    @hide="() => emit('hide')"
  >
    <q-card
      style="min-width: 350px"
      flat
      :class="`bg-${color} text-dark full-width q-pa-none ${cardClass}`"
    >
      <q-card-section class="full-width q-pa-none">
        <slot name="header">
          <q-toolbar>
            <!-- Inherit the card's own text colour: the card is light in light
                 mode and dark in dark mode, so a fixed `dark` icon disappears. -->
            <q-icon
              :name="mdiInformationVariant"
              size="md"
            />

            <q-toolbar-title>{{ $t(title) }}</q-toolbar-title>

            <q-btn
              v-close-popup
              flat
              round
              dense
              :icon="mdiChevronDown"
            />
          </q-toolbar>
        </slot>
      </q-card-section>
      <q-separator />
      <q-card-section>
        <slot />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>
